import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Chargement progressif : seules la page d'accueil et la page 404 sont dans le paquet
// principal ; chaque autre page (et ses graphiques, cartes, données) n'est téléchargée
// qu'à sa première visite. Avant, tout l'OAD était chargé d'un coup à l'ouverture.
// --- Site web (inchangé) ---
import Accueil from './components/SiteWeb/accueil';
import NotFound from './notfound';

const Blog = lazy(() => import('./components/SiteWeb/blog'));
const BlogContainer = lazy(() => import('./components/SiteWeb/blogContainer'));
const DecouvrirDiagoRisk = lazy(() => import('./components/SiteWeb/decouvrirDiagoRisk'));
const DiagnosticsClimatiques = lazy(() => import('./components/SiteWeb/diagnosticsClimatiques'));
const MentionsLegales = lazy(() => import('./components/SiteWeb/mentionslégales'));
const NousContacter = lazy(() => import('./components/SiteWeb/NousContacter'));
const Projets = lazy(() => import('./components/SiteWeb/projets'));
const ProtectionsDesDonnes = lazy(() => import('./components/SiteWeb/protectionsdesdonnées'));
const QuiSommesNous = lazy(() => import('./components/SiteWeb/quiSommesNous'));

// --- Compte ---
const Connexion = lazy(() => import('./components/Compte/Gestion_Compte/connexion'));
const Inscription = lazy(() => import('./components/Compte/Gestion_Compte/inscription'));
const InscriptionValidation = lazy(() => import('./components/Compte/Gestion_Compte/inscription_validation'));
const Profil = lazy(() => import('./components/Compte/Gestion_Compte/profil'));
const PageSimulations = lazy(() => import('./components/Compte/Simulations/page_simulations'));
const CreationExploitation = lazy(() => import('./components/Compte/creation_exploitation'));
const LocalisationInscription = lazy(() => import('./components/Loc_et_assol/localisation_inscription'));
const Assolement = lazy(() => import('./components/Compte/Assolement/assolement'));
const NewSimul = lazy(() => import('./components/Compte/Assolement/new_simul'));

// --- PDF ---
const RapportPDF = lazy(() => import('./components/PDF/0_rapport_pdf'));

// --- OAD hors menu ---
const Dr2050VueDensemble = lazy(() => import('./components/OAD/DiagoRisk2050/dr2050VueDensemble'));
const ColzaZI = lazy(() => import('./components/OAD/ColzaZI/colzaZI'));

// --- OAD : coquille + pages ---
const OADLayout = lazy(() => import('./components/layout/OADLayout'));
const TableauDeBord = lazy(() => import('./components/OAD/TableauDeBord/TableauDeBord'));
const ImpactsGlobaux = lazy(() => import('./components/OAD/2035-2050/ImpactsGlobaux/ImpactsGlobaux'));
const BesoinEnEau = lazy(() => import('./components/OAD/2035-2050/EauEtIrrigation/BesoinEnEau'));
const RentabiliteIrrigation = lazy(() => import('./components/OAD/2035-2050/EauEtIrrigation/RentabiliteIrrigation'));
const Tension = lazy(() => import('./components/OAD/2035-2050/EauEtIrrigation/Tension'));
const Classement = lazy(() => import('./components/OAD/2035-2050/Adaptations/Classement'));
const ChangementSemisVariete = lazy(() => import('./components/OAD/2035-2050/Adaptations/ChangementSemisVariete'));
const Substitution = lazy(() => import('./components/OAD/2035-2050/Adaptations/Substitution'));
const ModificationITK = lazy(() => import('./components/OAD/2035-2050/Adaptations/ModificationITK'));
const ComprendrePhenologie = lazy(() => import('./components/OAD/ComparerComprendre/Comprendre/Phenologie'));
const ComprendreFrequenceAleas = lazy(() => import('./components/OAD/ComparerComprendre/Comprendre/FrequenceAleas'));
const ComparerRisqueActuel = lazy(() => import('./components/OAD/ComparerComprendre/Comparer/RisqueActuel'));
const ComparerFrequenceAleas = lazy(() => import('./components/OAD/ComparerComprendre/Comparer/FrequenceAleas'));
const ComparerEau = lazy(() => import('./components/OAD/ComparerComprendre/Comparer/Eau'));
const ComparerPhenologie = lazy(() => import('./components/OAD/ComparerComprendre/Comparer/Phenologie'));
const Unitaire = lazy(() => import('./components/OAD/2026-2027/EauA3Mois/Unitaire'));
const TotalTerritoire = lazy(() => import('./components/OAD/2026-2027/EauA3Mois/TotalTerritoire'));
const CumulCulture = lazy(() => import('./components/OAD/2026-2027/EauA3Mois/CumulCulture'));
const HistoriqueBesoinEau = lazy(() => import('./components/OAD/2026-2027/EauA3Mois/HistoriqueBesoinEau'));
const Distribution = lazy(() => import('./components/OAD/2026-2027/EauA3Mois/Distribution'));
const OptimisationAssurance = lazy(() => import('./components/OAD/2026-2027/OptimisationAssurance/OptimisationAssurance'));
const OptimisationAssolement = lazy(() => import('./components/OAD/2026-2027/OptimisationAssolement/OptimisationAssolement'));

const OAD_DESACTIVE = true; // repasser à false pour réactiver l'OAD


// Écran affiché le temps qu'une page se charge (chaque page est un paquet séparé).
function ChargementPage() {
  return (
    <div className="chargement-page" role="status" aria-live="polite">
      Chargement…
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<ChargementPage />}>
      <Routes>
        {/* Site web */}
        <Route exact path="/" element={<Accueil />} />
        <Route exact path="/blog" element={<Blog />} />
        <Route exact path="/blog/:id" element={<BlogContainer />} />
        <Route exact path="/decouvrirDiagoRisk" element={<DecouvrirDiagoRisk />} />
        <Route exact path="/diagnostics_climatiques" element={<DiagnosticsClimatiques />} />
        <Route exact path="/mentionslegales" element={<MentionsLegales />} />
        <Route exact path="/nouscontacter" element={<NousContacter />} />
        <Route exact path="/projets" element={<Projets />} />
        <Route exact path="/protectiondesdonnees" element={<ProtectionsDesDonnes />} />
        <Route exact path="/quisommesnous" element={<QuiSommesNous />} />

        {!OAD_DESACTIVE && ( //enlever quand OK 
        <> {/* enlever quand OK */}
        {/* Compte */}
        <Route exact path="/connexion" element={<Connexion />} />
        <Route exact path="/inscription" element={<Inscription />} />
        <Route exact path="/inscriptionvalidation" element={<InscriptionValidation />} />
        <Route exact path="/monprofil" element={<Profil />} />
        <Route exact path="/simulations" element={<PageSimulations />} />
        <Route exact path="/localisation" element={<LocalisationInscription />} />
        <Route exact path="/nouvellesimulation" element={<NewSimul />} />
        <Route exact path="/assolement" element={<Assolement />} />
        <Route exact path="/admin/crea-exploit" element={<CreationExploitation />} />

        {/* Rapport PDF */}
        <Route exact path="/previsualisationrapport" element={<RapportPDF />} />

        {/* OAD hors Menu_OAD : entete_simple seule */}
        <Route exact path="/diagorisk2050" element={<Dr2050VueDensemble />} />
        <Route exact path="/colzaZI" element={<ColzaZI />} />

        {/* OAD : coquille commune (entete_simple + Menu_OAD) */}
        <Route path="/oad" element={<OADLayout />}>
        <Route path="tableau-de-bord" element={<TableauDeBord />} />
        </Route>

        {/* Les pages à niveaux 2 et 3 partagent la même coquille, mais leurs
            segments d'URL alimentent MenuOAD via useParams. */}
        <Route path="/oad/:niveau1" element={<OADLayout />}>
        <Route path="impacts-globaux" element={<ImpactsGlobaux />} />

        <Route path="eau-irrigation/besoin-en-eau" element={<BesoinEnEau />} />
        <Route path="eau-irrigation/rentabilite-irrigation" element={<RentabiliteIrrigation />} />
        <Route path="eau-irrigation/tension" element={<Tension />} />

        <Route path="adaptations/classement" element={<Classement />} />
        <Route path="adaptations/changement-semis-variete" element={<ChangementSemisVariete />} />
        <Route path="adaptations/substitution" element={<Substitution />} />
        <Route path="adaptations/itk" element={<ModificationITK />} />

        <Route path="comprendre/pheno" element={<ComprendrePhenologie />} />
        <Route path="comprendre/frequence-aleas" element={<ComprendreFrequenceAleas />} />

        <Route path="comparer/risque-actuel" element={<ComparerRisqueActuel />} />
        <Route path="comparer/frequence-aleas" element={<ComparerFrequenceAleas />} />
        <Route path="comparer/eau" element={<ComparerEau />} />
        <Route path="comparer/pheno" element={<ComparerPhenologie />} />

        <Route path="eau-3-mois/unitaire" element={<Unitaire />} />
        <Route path="eau-3-mois/territoire" element={<TotalTerritoire />} />
        <Route path="eau-3-mois/cumul-culture" element={<CumulCulture />} />
        <Route path="eau-3-mois/historique" element={<HistoriqueBesoinEau />} />
        <Route path="eau-3-mois/distribution" element={<Distribution />} />

        <Route path="optimisation-assurance" element={<OptimisationAssurance />} />
        <Route path="optimisation-assolement" element={<OptimisationAssolement />} />
        </Route>
        </>
        )} 

        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
